<template>
  <div class="vendor-form">
    <p class="vendor-form-label">
      {{ label }}<span class="text-ast" v-if="isRequired">*</span>
    </p>
    <div class="phone-input" :style="`border: ${disabled
      ? '1px solid rgba(118, 118, 118, 0.3);'
      : '1px solid rgba(118, 118, 118, 1)'
      };`
      ">
      <vue-tel-input v-model="phoneNumber" v-bind="vueTel.props" :disabled="disabled" />
      <!-- <the-mask
        class="phone-input__code"
        :style="
          `border-right: ${
            disabled
              ? '1px solid rgba(118, 118, 118, 0.3);'
              : '1px solid rgba(118, 118, 118, 1)'
          };`
        "
        :mask="['+###']"
        v-model="phoneCode"
        :disabled="disabled"
      />
      <the-mask
        class="phone-input__phone"
        :mask="['####################']"
        v-model="phoneNumber"
        :disabled="disabled"
      /> -->
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'modelName',
    'subModelName',
    'label',
    'mutationName',
    'storeName',
    'isRequired',
    'disabled',
  ],
  data() {
    return {
      vueTel: {
        props: {
          placeholder: 'Enter your phone',
          mode: 'international',
          inputOptions: {
            showDialCode: true,
          },
          disabledFormatting: false,
        },
      },
    }
  },
  computed: {
    // phoneCode: {
    //   get() {
    //     const phoneCode = this.$store.state[this.storeName][this.subModelName]
    //     return phoneCode
    //   },
    //   set: function (newValue) {
    //     this.$store.commit(this.mutationName, {
    //       name: this.subModelName,
    //       value: newValue,
    //     })
    //   },
    // },
    phoneNumber: {
      get() {
        let phone = this.$get(
          this.$store,
          `state.${this.storeName}.${this.modelName}`
        )

        return phone
      },
      set: function (newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
}
</script>
